// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"5d8e9ec0","233":"ac26eec5","503":"af168988","528":"bde76914","643":"c88d807f","873":"716ab88d","915":"6a6102ba"}[chunkId] + ".chunk.js";
};